module.exports = __webpack_public_path__ + "media/country_flags/al-d3369d3c.png";